/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {verifyGovernmentId} from '../api'

export const useMutationVerifyGovernmentId = createReactQueryMutationHook('verifyGovernmentId', verifyGovernmentId)
